import "../../../../../styles/Pages/Financial/CashInFlow/Dashboard/SheetLinks.styles.css";
import inflow from "../../../../../assets/Images/finance/inflow.png";
import universal from "../../../../../assets/Images/finance/universal.png";
import { ReactComponent as BsArrowRight } from "../../../../../assets/Icons/Universal/BsArrowRight.svg";
import { useNavigate } from "react-router-dom";

const SheetLinks = () => {
  const navigate = useNavigate();
  return (
    <div className="SheetLinksContainer">
      <div onClick={()=>navigate("/finance/cashinflow/dashboard/cashinflowsheet")} className="inflowSheet">
        <h3>
          Go to inflow sheet <BsArrowRight />
        </h3>
        <p>All the data of cash inflow you can track.</p>
        <div className="imageContainer">
          <div className="lines">
            <div style={{ backgroundColor: "#E4765C" }} className="line1"></div>
            <div style={{ backgroundColor: "#F6C8AC" }} className="line2"></div>
            <div style={{ backgroundColor: "#C77B6D" }} className="line3"></div>
          </div>
          <div className="image">
            <img src={inflow} alt="" />
          </div>
        </div>
      </div>
      <div onClick={()=>navigate("/finance/cashinflow/dashboard/universalsheet")} className="universalSheet">
        <h3>
          Go to universal sheet <BsArrowRight />
        </h3>
        <p>All the data of cash inflow and cash outflow you can track.</p>
        <div className="imageContainer">
          <div className="lines">
            <div style={{ backgroundColor: "#E4765C" }} className="line1"></div>
            <div style={{ backgroundColor: "#F6C8AC" }} className="line2"></div>
            <div style={{ backgroundColor: "#C77B6D" }} className="line3"></div>
          </div>
          <div className="image">
            <img src={universal} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SheetLinks;
